import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote, BadgeCheck } from 'lucide-react';
interface Testimonial {
  quote: string;
  text: string;
  author: string;
  location: string;
  age?: string;
}
const testimonials: Testimonial[] = [{
  quote: 'Por fin bajé la hinchazón que ni el gimnasio me quitaba',
  text: "Tengo 46 años y vivo en Concepción. Siempre andaba con la 'guatita' como un globo, sobre todo después de almuerzo. Compré el plan pensando que sería otra dieta más, pero el cambio en 4 días fue impresionante. Por primera vez en meses me puse mis jeans regalones sin que me quedara la marca del botón en la piel. Lo mejor es que no tuve que comprar cosas raras, todo lo pillé en el súper de la esquina.",
  author: 'Marcela T.',
  location: 'Concepción'
}, {
  quote: 'Ya no necesito desabrocharme el pantalón al llegar a la casa',
  text: "Mi gran problema era la 'Hora de la Once'. Aplicar el protocolo de sustitución que explica el libro me cambió la vida. Ya no llego a la noche sintiéndome pesada ni con acidez. Me siento con una energía que no tenía hace años. ¡Incluso mi marido empezó a comer lo mismo porque las recetas son ricas y rápidas!",
  author: 'Patricia R.',
  location: 'Santiago, Ñuñoa'
}, {
  quote: 'Funciona incluso con el estrés del trabajo',
  text: 'Como profe, paso todo el día corriendo y comía lo que pillaba. Estaba siempre inflamada y de mal humor. El kit de emergencia para comer fuera de casa es lo mejor que me pudo pasar. Ya llevo 2 semanas y mi abdomen se siente blando y ligero. Es increíble que algo tan simple como cambiar el orden de lo que comes haga tanta diferencia.',
  author: 'Carla M.',
  location: 'Valparaíso'
}, {
  quote: 'Ideal para las que no tenemos tiempo de cocinar',
  text: '¡Me encantó que las recetas de verdad toman 15 minutos! Yo no tengo tiempo para vivir en la cocina y este plan es súper pragmático. Las listas de compra del Líder me ahorran mucho tiempo y plata. ¡Totalmente recomendado para mujeres que andamos a mil!',
  author: 'Sonia L.',
  location: 'Puerto Montt'
}];
// Color rotation for disruptive layout
const cardStyles = [{
  bg: 'bg-brand-cream',
  border: 'border-brand-gold/30',
  rotation: '-rotate-1'
}, {
  bg: 'bg-white',
  border: 'border-brand-navy/10',
  rotation: 'rotate-1'
}, {
  bg: 'bg-brand-navy text-brand-cream',
  border: 'border-brand-gold/40',
  rotation: 'rotate-1',
  dark: true
}, {
  bg: 'bg-brand-cream',
  border: 'border-brand-gold/30',
  rotation: '-rotate-1'
}];
export function Testimonials() {
  return <section className="py-14 md:py-16 bg-gradient-to-b from-brand-cream via-white to-brand-cream relative overflow-hidden" data-id="element-231">
      {/* Decorative scribbles */}
      <div className="absolute top-10 left-10 w-32 h-32 bg-brand-gold/10 rounded-full blur-2xl" data-id="element-232"></div>
      <div className="absolute bottom-20 right-10 w-40 h-40 bg-brand-green/10 rounded-full blur-3xl" data-id="element-233"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl relative z-10" data-id="element-234">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-235">
          <div className="inline-flex items-center gap-2 bg-brand-gold/15 text-brand-gold px-4 py-1.5 rounded-full font-bold text-xs uppercase tracking-wider mb-5" data-id="element-236">
            <BadgeCheck className="w-4 h-4" data-id="element-237" />
            Testimonios verificados
          </div>

          <h2 className="text-3xl md:text-5xl font-serif font-bold text-brand-navy leading-tight max-w-3xl mx-auto" data-id="element-238">
            Lo que dicen quienes ya apagaron{' '}
            <span className="relative inline-block" data-id="element-239">
              <span className="relative z-10 text-brand-gold" data-id="element-240">
                el "Fuego Interno"
              </span>
              <motion.span initial={{
              scaleX: 0
            }} whileInView={{
              scaleX: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.8,
              delay: 0.4,
              ease: 'easeOut'
            }} className="absolute -bottom-1 left-0 right-0 h-3 bg-brand-gold/25 -z-0 origin-left rounded-full" data-id="element-241" />
            </span>
          </h2>

          <div className="flex items-center justify-center gap-1 mt-6" data-id="element-242">
            {[...Array(5)].map((_, i) => <motion.div key={i} initial={{
            opacity: 0,
            scale: 0,
            rotate: -30
          }} whileInView={{
            opacity: 1,
            scale: 1,
            rotate: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.5 + i * 0.08,
            type: 'spring',
            stiffness: 200
          }} data-id="element-243">
                <Star className="w-5 h-5 fill-brand-gold text-brand-gold" data-id="element-244" />
              </motion.div>)}
            <span className="ml-2 text-sm text-brand-navy/70 font-medium" data-id="element-245">
              +1.200 mujeres chilenas
            </span>
          </div>
        </motion.div>

        {/* Disruptive grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-246">
          {testimonials.map((t, i) => {
          const style = cardStyles[i];
          const isDark = (style as any).dark;
          return <motion.article key={i} initial={{
            opacity: 0,
            y: 40,
            rotate: 0
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5,
            delay: i * 0.1,
            ease: 'easeOut'
          }} whileHover={{
            y: -6,
            rotate: 0,
            transition: {
              duration: 0.3
            }
          }} className={`
                  ${style.bg} ${style.border}
                  ${i % 2 === 0 ? 'md:translate-y-4' : 'md:-translate-y-4'}
                  ${style.rotation} hover:rotate-0
                  relative p-7 md:p-9 rounded-3xl border-2 shadow-lg
                  transition-all duration-300
                `} data-id="element-247">
                {/* Big floating quote mark */}
                <div className={`absolute -top-5 -left-2 w-14 h-14 rounded-2xl flex items-center justify-center shadow-lg ${isDark ? 'bg-brand-gold text-brand-navy' : 'bg-brand-navy text-brand-gold'}`} data-id="element-248">
                  <Quote className="w-7 h-7" strokeWidth={2.5} data-id="element-249" />
                </div>

                {/* Stars */}
                <div className="flex gap-0.5 mb-4 mt-2" data-id="element-250">
                  {[...Array(5)].map((_, s) => <Star key={s} className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-251" />)}
                </div>

                {/* Headline quote */}
                <h3 className={`font-serif font-bold text-xl md:text-2xl leading-snug mb-4 ${isDark ? 'text-brand-gold' : 'text-brand-navy'}`} data-id="element-252">
                  "{t.quote}"
                </h3>

                {/* Body */}
                <p className={`text-sm md:text-base leading-relaxed mb-6 ${isDark ? 'text-brand-cream/85' : 'text-gray-700'}`} data-id="element-253">
                  {t.text}
                </p>

                {/* Author */}
                <div className={`flex items-center gap-3 pt-4 border-t ${isDark ? 'border-white/15' : 'border-brand-navy/10'}`} data-id="element-254">
                  <div className={`w-11 h-11 rounded-full flex items-center justify-center font-serif font-bold text-lg shrink-0 ${isDark ? 'bg-brand-gold text-brand-navy' : 'bg-brand-navy text-brand-gold'}`} data-id="element-255">
                    {t.author.charAt(0)}
                  </div>
                  <div className="flex-1" data-id="element-256">
                    <p className={`font-bold ${isDark ? 'text-white' : 'text-brand-navy'}`} data-id="element-257">
                      {t.author}
                    </p>
                    <p className={`text-xs ${isDark ? 'text-brand-cream/60' : 'text-gray-500'}`} data-id="element-258">
                      {t.location}
                    </p>
                  </div>
                  <div className={`flex items-center gap-1 text-xs font-medium ${isDark ? 'text-brand-green' : 'text-brand-green'}`} data-id="element-259">
                    <BadgeCheck className="w-4 h-4" data-id="element-260" />
                    <span className="hidden sm:inline" data-id="element-261">Verificado</span>
                  </div>
                </div>
              </motion.article>;
        })}
        </div>

        {/* Footer note */}
        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-center text-sm text-brand-navy/60 mt-12 italic" data-id="element-262">
          Resultados individuales pueden variar. Testimonios reales enviados por
          nuestras clientas.
        </motion.p>
      </div>
    </section>;
}